import { useMutation } from "@apollo/client";

import { GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput } from "~/__generated__";

import { SettingsFunctionTypeEditRoute_AddObservationTypeDocument } from "../mutations.generated";

export default function useSettingsFunctionTypeEditRoute_AddObservationType() {
    const [mutate, { loading, error }] = useMutation(SettingsFunctionTypeEditRoute_AddObservationTypeDocument);

    const addFunctionTypeObservationType = async (
        input: GqlSettingsEcologicalFunctionTypeObservationTypeLinkInput,
    ): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        addFunctionTypeObservationType,
        loading,
        error,
    };
}
